"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * User Service
 * Provides OIDC and Security endpoints as well as CRUD operations for SAVE and E-Verify Users and Points of Contact.
 *
 * The version of the OpenAPI document: 2.7.28
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SaveUserRoleToJSON = exports.SaveUserRoleFromJSONTyped = exports.SaveUserRoleFromJSON = exports.SaveUserRole = void 0;
/**
 * see https://maestro.dhs.gov/confluence/display/AR/Users+and+Roles for capabilities. Sub-roles for GENERAL_USER are provided by verificationResponseCode.
 * @export
 * @enum {string}
 */
var SaveUserRole;
(function (SaveUserRole) {
    SaveUserRole["SUPERUSER"] = "SUPER_USER";
    SaveUserRole["SUPERVISOR"] = "SUPERVISOR";
    SaveUserRole["GENERALUSER"] = "GENERAL_USER";
    SaveUserRole["THIRDSTEPSUPERVISOR"] = "THIRD_STEP_SUPERVISOR";
    SaveUserRole["THIRDSTEPUSER"] = "THIRD_STEP_USER";
    SaveUserRole["WEBSERVICE"] = "WEB_SERVICE";
    SaveUserRole["ONBOARDING"] = "ONBOARDING";
    SaveUserRole["EVSTAR"] = "EV_STAR";
    SaveUserRole["UNKNOWN"] = "UNKNOWN";
})(SaveUserRole = exports.SaveUserRole || (exports.SaveUserRole = {}));
function SaveUserRoleFromJSON(json) {
    return SaveUserRoleFromJSONTyped(json, false);
}
exports.SaveUserRoleFromJSON = SaveUserRoleFromJSON;
function SaveUserRoleFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.SaveUserRoleFromJSONTyped = SaveUserRoleFromJSONTyped;
function SaveUserRoleToJSON(value) {
    return value;
}
exports.SaveUserRoleToJSON = SaveUserRoleToJSON;
